import {useQuery} from "react-query";
import roleService from "../../services/RoleService";
import {RoleSearchRequest} from "../../models/user";

export default function useRoles(request?: RoleSearchRequest) {
   return useQuery(['roles', request], () => roleService.search(request));
}